import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';

export function DescriptionAndParameters({ product }: { product: ProductDetailData }) {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);

  return (
    <div className="flex w-full flex-col items-start justify-start gap-12 md:flex-row md:justify-between md:gap-8 lg:gap-12">
      <HtmlRenderer html={selectedVariant?.description || product.description} />
    </div>
  );
}
